module.exports = __webpack_public_path__ + "static/media/doggy.c4ef102a.png";